import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = listStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		SkladOzn: [],
	},
	filter: {
		SkladOzn: null as number | null,
	},
	tableSetting: {},
	localState: {},
	rowDetail: null,
	extraActions: {
		async deleteItem({ state }, id: string | number) {
			const resp = await apiProvider.deleteEntity(id);

			if (resp.status === 200) {
				const index = state.table.rows.findIndex((row) => row.cells[state.table!.cellNames!.idColumn] === id);

				state.table.rows.splice(index, 1);
			}
		},
	},
	extraGetters: {},
	extraMutations: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
